import {Component, OnInit} from '@angular/core';
import {IonicModule, NavController} from "@ionic/angular";

import {UiHelperService} from "@services/ui-helper/ui-helper.service";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
  standalone: true,
  imports: [IonicModule,CommonModule]
})
export class BackButtonComponent implements OnInit {

  constructor(private navCtrl: NavController,
              public uiHelper: UiHelperService) {
  }

  ngOnInit() {
  }

  goBack() {
    this.navCtrl.back();
  }

}
